import TableCellLink from "ds/components/Table/Row/CellLink";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import useAnalytics from "hooks/useAnalytics";

import { IntegrationsAzureUsedByTableCellProps } from "./types";

const IntegrationsAzureUsedByTableNameCell = ({
  item,
  ...cellProps
}: IntegrationsAzureUsedByTableCellProps) => {
  const trackAnalytics = useAnalytics();

  return (
    <TableSimpleCell {...cellProps} role="rowheader">
      <TableCellLink
        href={`/${item.isModule ? "module" : "stack"}/${item.stackId}`}
        onPress={() =>
          trackAnalytics("Stack link clicked", {
            name: item.stackName,
            type: item.isModule ? "module" : "stack",
          })
        }
      >
        {item.stackName}
      </TableCellLink>
    </TableSimpleCell>
  );
};

export default IntegrationsAzureUsedByTableNameCell;
